/** @jsxImportSource @emotion/react */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { formatCheck2Frontend } from "../../../../actions/Checks/util";
import { CHECK_LOCATION, Check } from "../../../../actions/Layers/constants";
import { AVOCADO_FRUIT, MANGO_FRUIT } from "../../../../actions/Tenants/config/fruitNames";
import { useLayerChecks } from "../../../../hooks/useLayerChecks";
import { callAvosApi } from "../../../../utils/useAvosApiHook";
import { Button } from "../../../Helper/Button";
import { Loading } from "../../../Helper/Loading";
import { BoxItem } from "../../AddItem/components/Summary/Boxes";

import { useRouteLayer, useRouteLayerQuery } from "../../../../hooks/useCurrentEntities";

export default function BoxWeightCheck({ title }: { title: string }) {
    const layer = useRouteLayer();
    const isLoading = useRouteLayerQuery().isLoading;
    const [localCheck, setCheck] = useState<Check | null>(null);
    const { data: checks = [] } = useLayerChecks(layer?.tenant_id, layer?.id ?? undefined);
    const boxWeightChecks = checks.filter((i) => i.location === CHECK_LOCATION.BOX_WEIGHT).sort((a, b) => b.check_id - a.check_id);
    const fruitTypeCheck = layer.fruit_type === AVOCADO_FRUIT || layer.fruit_type === MANGO_FRUIT; // Only display for Avocado or Mango


    const boxWeightCheckId = boxWeightChecks[0];
    useEffect(() => {
        if (!boxWeightCheckId) {
            return;
        }
        callAvosApi(`/checks/${boxWeightCheckId.check_id}/`).then((response) => {
            setCheck(formatCheck2Frontend(response.data));
        });
    }, [boxWeightCheckId]);

    if (isLoading) {
        return <Loading />;
    }

    if (!layer || !checks) {
        return null;
    }

    const formatAvocado2Frontend = (avocados) => {
        if (Array.isArray(avocados)) {
            return avocados.map((avocado) => {
                const { meta, ...rest } = avocado;
                const metaObject = meta.reduce((acc, item) => ({
                    ...acc,
                    [item.key]: item.value
                }), {});

                return { ...rest, ...metaObject };
            });
        }
        return [];
    };

    if (!fruitTypeCheck || !localCheck) {
        return null;
    }

    return (
        <>
            <div className="d-flex">
                <h3 className="mb-0">{title}</h3>

                <div className="ms-auto">
                    {localCheck && (
                        <Button
                            color="secondary"
                            title={title}
                            outline
                            size="xs"
                            to={`/layer/${layer.id}/add-check/${boxWeightCheckId.check_id}/summary`}
                            tag={Link}
                        >
                            View Check
                        </Button>
                    )}
                </div>
            </div>

            <div className="pt-3">
                {!localCheck && <div className="text-warning">No {title} available.</div>}
                {localCheck?.avocados && <BoxItem avocados={formatAvocado2Frontend(localCheck.avocados)} check={localCheck} layer={layer} title={`Check ${localCheck.check_id}`} />}
            </div>
        </>
    );
}
